import React from "react";
import Modal from "react-modal";
import Spinner from "../../../../Animations/Spinner.jsx";
import { loadingModalStyle } from "../utils/constants";

/**
 * LoadingModal Component
 * Simple modal for displaying loading spinner
 */
const LoadingModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={loadingModalStyle}
    >
      <Spinner />
    </Modal>
  );
};

export default LoadingModal;
